import {State} from "./types";
import {initialState} from "./initial-state";
import {setRequestStatus} from "../request-status";
import {Pagination, RequestStatus} from "interfaces";
import {PayloadAction, createSlice} from "@reduxjs/toolkit";
import {get, getById, getClientProducts, removeClientProduct} from "./thunks";

export const clients = createSlice({
  name: "clients",
  initialState,
  reducers: {
    setClientsSliceRequestStatus: function (
      state,
      action: PayloadAction<{
        name: keyof State["request"];
        status: RequestStatus;
      }>
    ) {
      const {name, status} = action["payload"];
      state["request"][name] = status;
    },
    setPagination: function (state, action: PayloadAction<Pagination>) {
      state["pagination"] = action["payload"];
    },
    setClientProductsPagination: function (
      state,
      action: PayloadAction<State["clientProductsPagination"]>
    ) {
      state["clientProductsPagination"] = action["payload"];
    },
    clearClients: function (state) {
      state["clients"] = [];
    },
    clearClientProducts: function (state) {
      state["clientProducts"] = [];
    },
    resetClientSlice: function (state) {
      state["client"] = initialState["client"];
      state["clientProducts"] = initialState["clientProducts"];
      state["request"]["client"] = setRequestStatus("initial");
      state["request"]["clientProducts"] = setRequestStatus("initial");
      state["clientProductsPagination"] =
        initialState["clientProductsPagination"];
    },
  },
  extraReducers: function (builder) {
    builder.addCase(get.fulfilled, function (state, action) {
      const {data, refresh} = action["payload"];
      const {rows, count} = data;
      const nextRows = refresh ? rows : [...state["clients"], ...rows];
      state["clients"] = nextRows;
      state["request"]["clients"] = setRequestStatus("success");
      state["pagination"]["hasMore"] = nextRows["length"] < count;
    });
    builder.addCase(get.rejected, function (state) {
      state["request"]["clients"] = setRequestStatus("error");
    });

    builder.addCase(getById.fulfilled, function (state, action) {
      state["client"] = action["payload"]["data"];
      state["request"]["client"] = setRequestStatus("success");
    });
    builder.addCase(getById.rejected, function (state) {
      state["request"]["client"] = setRequestStatus("error");
    });

    builder.addCase(getClientProducts.fulfilled, function (state, action) {
      const {rows, count} = action["payload"]["data"];
      const nextRows = [...state["clientProducts"], ...rows];
      state["clientProducts"] = nextRows;
      state["request"]["clientProducts"] = setRequestStatus("success");
      state["clientProductsPagination"]["hasMore"] = nextRows["length"] < count;
    });
    builder.addCase(getClientProducts.rejected, function (state) {
      state["request"]["clientProducts"] = setRequestStatus("error");
    });

    builder.addCase(removeClientProduct.fulfilled, function (state, action) {
      state["clientProducts"] = state["clientProducts"].filter(
        (product) => product["id"] !== action["payload"]
      );
    });
  },
});

export default clients["reducer"];
export const {
  clearClients,
  setPagination,
  resetClientSlice,
  clearClientProducts,
  setClientProductsPagination,
  setClientsSliceRequestStatus,
} = clients["actions"];
